import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { makeBgImage } from '../../../../helpers/common';
import { propShape, propStr } from '../../../../helpers/custom-prop-types';
class PdfImageModalThumbnailSliderBottomItem extends Component {
    constructor(props) {
        super(props);
        this.getState = (props) => {
            const { dataAttributes, url } = props;
            return {
                dataAttributes: Object.assign(Object.assign({}, dataAttributes), { 'data-analytics': 'slider' }),
                style: makeBgImage(url),
            };
        };
        this.state = this.getState(props);
    }
    shouldComponentUpdate(nextProps) {
        const { dataAttributes, url } = this.props;
        if (url !== nextProps.url || dataAttributes !== nextProps.dataAttributes) {
            this.setState(this.getState(nextProps));
            return false;
        }
        return true;
    }
    render() {
        const { dataAttributes, style } = this.state;
        return (_jsx("li", Object.assign({ className: 'slide-item' }, { children: _jsx("div", Object.assign({ style: style }, dataAttributes)) })));
    }
}
PdfImageModalThumbnailSliderBottomItem.propTypes = {
    dataAttributes: propShape().isRequired,
    url: propStr().isRequired,
};
export default PdfImageModalThumbnailSliderBottomItem;
